interface ButtonProps {
    href?: string;
    onClick?: () => void;
    text: string;
    className?: string; // Allow custom styles
    children?: string; // Allow children elements
    style?: React.CSSProperties; // Allow inline styles
}
export const Button = ({href, onClick, text, className, children, style} : ButtonProps) => {
    const baseClass = "m-1.5 bg-primary-400 hover:bg-primary-600 font-bold py-3 px-6  font-[FoundersGroteskMonoRegular] rounded-[30px]";
    const combinedClasses = className ? `${className} ${baseClass}` : baseClass;
    if(href) {
        return (
            <a href={href} className={combinedClasses} style={style}>
                {children || text}
            </a>
        )
    }
    return (
        <button onClick={onClick} className={combinedClasses} style={style}>
            {text}
        </button>
    )
}